import { useEffect } from "react";

const Helmet = ({
  title,
  description,
  image,
  url,
  type = "website",
}) => {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (attr, name, content) => {
      if (!content) return;

      let element = document.head.querySelector(
        `meta[${attr}="${name}"]`
      );

      if (!element) {
        element = document.createElement("meta");
        element.setAttribute(attr, name);
        document.head.appendChild(element);
      }

      element.setAttribute("content", content);
    };

    // ✅ Basic SEO
    setMeta("name", "description", description);

    // ✅ Open Graph (Facebook, WhatsApp, Messenger)
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:image", image);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", type);

    // Recommended image size
    setMeta("property", "og:image:width", "1200");
    setMeta("property", "og:image:height", "630");

  }, [title, description, image, url, type]);

  return null;
};

export default Helmet;